import {
  BackgroundImgixWrapper,
  EntityImagePreview,
} from '@common/components/BackgroundImgixWrapper';
import { LoadingPill } from '@common/components/LoadingPill/LoadingPill';
import { DiscountBanner, FromPrice } from '@common/components/Price';
import { getImageOrGalleryImage } from '@utils/helpers';
import { FC } from 'react';
import { Link } from 'shared-routing';
import { Item } from 'shared-types/Common';
import { Details, EntityItem, Title } from './Entity.styles';

type EntityProps = {
  route: string;
  item: Item;
  isLoadingPrice?: boolean;
};

export const Entity: FC<EntityProps> = ({ item, route, isLoadingPrice }) => {
  const image = getImageOrGalleryImage(item);
  return (
    <EntityItem key={item.id}>
      <Link
        route={route}
        params={{
          id: item.id,
        }}
      >
        {image && (
          <BackgroundImgixWrapper src={image?.url}>
            <EntityImagePreview background={image?.url} />
            <DiscountBanner discount={item.discount} />
          </BackgroundImgixWrapper>
        )}
        <Details>
          <Title>{item.name}</Title>
          {isLoadingPrice ? <LoadingPill /> : item.price ? <FromPrice {...item} /> : null}
        </Details>
      </Link>
    </EntityItem>
  );
};
